import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import Header from './components/Header.js';
import Frame from './components/Frame.js';
import Map from './components/Map.js';
import Fade from './components/Fade.js';
import {
  Figure,
  withScrollAnimationDebug,
  ScrollAnimationTimeline,
  ScrollAnimationTarget,
} from '@studiometa/ui';
import { BREAKPOINTS, isDev } from './config.js';

/**
 * @typedef {{
 *   $children: {
 *     Figure: Figure[],
 *     Accordion: Array<Promise<import('./components/Accordion.js').default>>
 *     Slider: Array<Promise<import('./components/Slider.js').default>>
 *   }
 * }} AppProps
 */

/**
 * App class.
 * @augments {Base<AppProps>}
 */
class App extends Base {
  /**
   * App config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'App',
    log: isDev(),
    components: {
      Header,
      Figure,
      Frame,
      Map,
      ScrollAnimationTimeline: withScrollAnimationDebug(ScrollAnimationTimeline),
      ScrollAnimationTarget,
      '[data-fade]': Fade,
      Dropdown: () => importWhenVisible(() => import('./components/Dropdown.js'), 'Dropdown'),
      ViewList: () => importWhenVisible(() => import('./components/ViewList.js'), 'ViewList'),
      Slider: () => importWhenVisible(() => import('./components/Slider.js'), 'Slider'),
      SliderTabs: () => importWhenVisible(() => import('./components/sliderTabs.js'), 'SliderTabs'),
      Accordion: () => importWhenVisible(() => import('./components/Accordion.js'), 'Accordion'),
    },
  };
}

export default createApp(App, {
  root: document.documentElement,
  breakpoints: BREAKPOINTS,
});
